import {groq} from 'next-sanity';

import type {LinkFragment} from '@/modules/foundation/sanity/link/query';
import {LINK_FRAGMENT} from '@/modules/foundation/sanity/link/query';

import type {LinkListSelectionSchema} from './schema';

export const LINK_LIST_SELECTION_FRAGMENT = groq`
	...,
	linkItems[]{
		...,
		link{
			${LINK_FRAGMENT}
		}
	}
`;

type LinkItem = NonNullable<LinkListSelectionSchema['linkItems']>[number];

type ResolvedLinkItem = Omit<LinkItem, 'link'> & {
	link: LinkFragment;
};

export type LinkListSelectionFragment = Omit<LinkListSelectionSchema, 'linkItems'> & {
	linkItems: ResolvedLinkItem[];
};
